export default __webpack_public_path__ + "static/media/google.0838fe27.svg";